import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle, onMenu }) => (
  <header className={'navbar'}>
    <div
      style={{
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <div className="sidebar-button">
      <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" viewBox="0 0 448 512" className="icon" width="20px" height="20px" onClick={onMenu}><path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"></path></svg>
      </div>

      <h1 style={{ fontSize: 16, marginTop: 0, marginLeft: '2rem', display: 'inline' }}>
        <Link
          to="/"
          style={{
            textDecoration: `none`,
            color: `#526375`
          }}
        >
          {siteTitle}
        </Link>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
  onMenu: PropTypes.func
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
